<template>
	<swiper
		:style="{
			'--swiper-pagination-color': swiperPaginationColor,
			'--swiper-pagination-bullet-inactive-color': '#E5E5F8',
			'--swiper-pagination-bullet-inactive-opacity': '1',
			'--swiper-pagination-bullet-size': '12px',
			'--swiper-pagination-bullet-horizontal-gap': '6px',
			'--swiper-pagination-top': swiperPaginationTop,
			'padding-bottom': paddingBottom,
		}"
		:modules="modules"
		:slidesPerView="'auto'"
		:pagination="{
			dynamicBullets: true,
		}"
		:navigation="{
			nextEl: '.custom-next-button',
			prevEl: '.custom-prev-button',
		}"
		@swiper="onSwiper"
		@slideChange="
			() => {
				console.log(
					lastPaginatinoClasses,
					lastPaginatinoClasses.includes('swiper-pagination-bullet')
				);
			}
		"
		@reachEnd="
			(event) => {
				console.log(event);
			}
		"
		class="mySwiper"
		:class="{
			'my-swiper-pagination': mySwiperPagination,
		}"
	>
		<slot></slot>

		<div
			@click="prevSlide"
			class="custom-prev-button"
			ref="swiperPrevSlide"
		>
			<slot name="prev-btn"></slot>
		</div>
		<div
			@click="nextSlide"
			class="custom-next-button"
			ref="swiperNextSlide"
		>
			<slot name="next-btn"></slot>
		</div>
	</swiper>
</template>

<script>
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import { Swiper } from "swiper/vue";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { ref, reactive } from "vue";

// Import Swiper styles
export default {
	name: 'BaseSwiper',
	components: {
		Swiper,
	},
	props: {
		swiperPaginationTop: {
			type: String,
			required: false,
			default: "calc(100% - 24px)",
		},
		paddingBottom: {
			type: String,
			required: false,
			default: "45px",
		},
		swiperPaginationColor: {
			type: String,
			required: false,
			default: "#413663",
		},
		mySwiperPagination: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			interval: null,
		};
	},
	methods: {
		prevSlide() {
			this.$refs.swiper?.$swiper.slidePrev();
		},
		nextSlide() {
			this.$refs.swiper?.$swiper.slideNext();
		},
		getSlotHTML(className) {
			return this.$el?.nextElementSibling?.getElementsByClassName?.(
				className
			)?.[0]?.innerHTML;
		},
		initButtons() {
			let pagination_container =
				document.querySelector(".swiper-pagination");

			if (
				pagination_container &&
				!pagination_container.querySelector(".prevSlide") &&
				!pagination_container.querySelector(".nextSlide")
			) {
				console.log(
					"this.$slots?.['prev-btn']",
					this.$slots?.["prev-btn"]?.()
				);
				const slotPrevBtnHTML = this.getSlotHTML(
					"slot-prev-btn-wrapper"
				);
				const slotNextBtnHTML = this.getSlotHTML(
					"slot-next-btn-wrapper"
				);

				let prevElement = document.createElement("div");
				if (slotPrevBtnHTML) {
					prevElement.innerHTML = slotPrevBtnHTML;
				}
				prevElement.classList.add("prevSlide");
				prevElement.addEventListener("click", (event) => {
					this.$refs.swiperPrevSlide.click();
					this.lastPaginatinoClasses = event.target.className;
				});
				let nextElement = document.createElement("div");
				if (slotPrevBtnHTML) {
					nextElement.innerHTML = slotNextBtnHTML;
				}
				nextElement.classList.add("nextSlide");
				nextElement.addEventListener("click", (event) => {
					this.$refs.swiperNextSlide.click();
					this.lastPaginatinoClasses = event.target.className;
				});
				pagination_container?.insertBefore?.(
					prevElement,
					pagination_container.firstChild
				);
				pagination_container.append(nextElement);
			}
			let pagination_bullets = document.querySelectorAll(
				".swiper-pagination-bullet"
			);
			pagination_bullets.forEach((bullet) => {
				bullet.addEventListener("click", (event) => {
					this.lastPaginatinoClasses = event.target.className;
				});
			});
		},
	},
	setup() {
		const lastPaginatinoClasses = reactive(ref(""));
		const onSwiper = (swiper) => {
			console.log(swiper);
		};
		const onSlideChange = (swiper) => {
			console.log("slide change", swiper);
		};
		return {
			onSwiper,
			onSlideChange,
			lastPaginatinoClasses,
			modules: [Navigation, Pagination, Scrollbar, A11y],
		};
	},
};
</script>

<style lang="scss">
@mixin adaptiv-font($from, $to, $screenFrom, $screenTo, $className) {
	$addSize: $to - $from;
	$screenTo: $screenTo - $screenFrom;
	.#{$className} {
		max-width: calc(
			#{$from + px} + #{$addSize} *
				((100vw - #{$screenFrom + px}) / #{$screenTo})
		);
	}
}
@mixin media-width($from, $to) {
	@media (min-width: #{$from}px) and (max-width: #{$to}px) {
		@content; // Вставляем содержимое, переданное при вызове миксина
	}
}
@include media-width(1205, 1920) {
	@include adaptiv-font(334, 968, 1205, 1920, "adaptive-max-w");
}
@include media-width(1026, 1920) {
	@include adaptiv-font(
		626,
		1520,
		1026,
		1920,
		"ab-course-events-adaptive-max-w"
	);
}
@media (min-width: 1920px) {
	.ab-course-events-adaptive-max-w {
		max-width: 1520px;
	}
}

.swiper {
	width: 100%;
	height: 100%;
}

.swiper-button-next,
.swiper-button-prev {
	top: unset;
	right: unset;
	left: unset;
	bottom: -6px;
}
.swiper-button-prev {
	right: 53%;
}

.swiper-button-next {
	left: 53%;
}

.my-swiper-pagination .swiper-pagination {
	display: flex;
	align-items: center;
	width: 70px !important;

	&:has(
			> span:nth-child(3)
				+ span:last-child:not(.swiper-pagination-bullet-active)
		) {
		width: 80px !important;
	}
	&:has(> span:nth-child(3) + span:last-child) {
		padding-left: 10px;
	}
	transition: all 0.3s;

	> span:not(.swiper-pagination-bullet-active) {
		transform: scale(1);
	}
	> span:last-child.swiper-pagination-bullet-active {
		left: revert;
	}
	&:has(> span:nth-child(3) + span:last-child.swiper-pagination-bullet-active)
		> span {
		transform: translateX(0px);
	}
	&:has(> span:nth-child(3).swiper-pagination-bullet-active + span:last-child)
		> span {
		transform: translateX(24px);
	}
	&:has(> span:nth-child(2) + span.swiper-pagination-bullet-active:last-child)
		> span {
		transform: translateX(24px);
	}
	&:has(> span:first-child.swiper-pagination-bullet-active) > span,
	&:has(> span:nth-child(2).swiper-pagination-bullet-active) > span {
		left: 0 !important;
	}
	&:has(
			> span.swiper-pagination-bullet-active:not(:last-child):not(
					:first-child
				):not(:nth-child(2))
		)
		> span {
		transform: translateX(-24px);
	}
	> span {
		min-width: 12px;
	}
}

.prevSlide:empty {
	content: url(@/shared/assets/svg/arrow-left.svg);
}
.prevSlide {
	margin-right: 18px;
}
.nextSlide:empty {
	content: url(@/shared/assets/svg/arrow-right.svg);
}
.nextSlide {
	margin-left: 18px;
}
.prevSlide:empty:hover,
.nextSlide:empty:hover {
	opacity: 0.5;
}
.prevSlide:empty,
.nextSlide:empty {
	opacity: 0.25;
}
.prevSlide,
.nextSlide {
	cursor: pointer;
	user-select: none;
}

.custom-next-button,
.custom-prev-button {
	position: absolute;
	bottom: 0;
}
.custom-prev-button {
	right: calc(50% + 60px);
}
.custom-next-button {
	left: calc(50% + 60px);
}
</style>
